import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../firebase';

export const DEFAULT_MARKETING_SITE_BASE_URL = 'https://perrisfreshmeet.com';

export const DEFAULT_MARKETING_PATHS = {
  rules: '/rules',
  map: '/map',
  location: '/#getting-there',
};

/**
 * Strip trailing slashes from a base URL (no trailing slash contract).
 * @param {string} raw
 * @returns {string}
 */
export function normalizeMarketingBaseUrl(raw) {
  const s = (raw || '').toString().trim();
  if (!s) return '';
  return s.replace(/\/+$/, '');
}

/**
 * @param {string} baseUrl - normalized, no trailing slash
 * @param {string} path - starts with / or # or empty
 * @returns {string}
 */
export function joinMarketingUrl(baseUrl, path) {
  const base = normalizeMarketingBaseUrl(baseUrl) || DEFAULT_MARKETING_SITE_BASE_URL;
  const p = (path || '').toString();
  if (!p) return base;
  if (p.startsWith('#')) return `${base}${p}`;
  if (p.startsWith('/')) return `${base}${p}`;
  return `${base}/${p}`;
}

/**
 * @returns {Promise<{ marketingSiteBaseUrl: string, marketingPaths: { rules: string, map: string, location: string } }>}
 */
export async function getPublicSiteMarketingConfig() {
  try {
    const snap = await getDoc(doc(firestore, '_config', 'publicSite'));
    const data = snap.exists() ? snap.data() : {};
    const base = normalizeMarketingBaseUrl(data?.marketingSiteBaseUrl);
    const pathsIn = data?.marketingPaths && typeof data.marketingPaths === 'object' ? data.marketingPaths : {};
    return {
      marketingSiteBaseUrl: base || DEFAULT_MARKETING_SITE_BASE_URL,
      marketingPaths: {
        rules: typeof pathsIn.rules === 'string' && pathsIn.rules.trim() ? pathsIn.rules.trim() : DEFAULT_MARKETING_PATHS.rules,
        map: typeof pathsIn.map === 'string' && pathsIn.map.trim() ? pathsIn.map.trim() : DEFAULT_MARKETING_PATHS.map,
        location:
          typeof pathsIn.location === 'string' && pathsIn.location.trim()
            ? pathsIn.location.trim()
            : DEFAULT_MARKETING_PATHS.location,
      },
    };
  } catch {
    return {
      marketingSiteBaseUrl: DEFAULT_MARKETING_SITE_BASE_URL,
      marketingPaths: { ...DEFAULT_MARKETING_PATHS },
    };
  }
}
